<mat-expansion-panel
  [expanded]="isPanelExpanded$ | async"
  togglePosition="before"
  class="shape-list-shape shape-list-padding"
  [style.border-left-color]="shapeColor$ | async"
  [attr.data-shape-index]="shapeIndex"
  [class.visibility-off]="(visibility$ | async) === 0"
  [class.selected-shape-item]="isShapeSelected$ | async"
  (click)="modifyShapeSelection(shapeStore.state(), $event)"
  (afterCollapse)="afterCollapse()"
  (afterExpand)="afterExpand()"
>
  <mat-expansion-panel-header collapsedHeight="60px">
    <mat-panel-title class="subtitle-03">
      <div
        class="missing-required-tag"
        *ngIf="missingRequiredTag$ | async; else label"
      >
        Incomplete
      </div>
      <ng-template #label>
        <h3-objectless-shape-label
          [class.with-feedback-flag]="hasFeedback$ | async"
          [class.within-group-shape]="memberOfGroup"
          [class.selected-shape-item]="isShapeSelected$ | async"
          [shapeStore]="shapeStore"
        ></h3-objectless-shape-label>
      </ng-template>
      <span
        class="shape-index"
        [class.missing-required-tag]="missingRequiredTag$ | async"
        >#{{ this.shapeIndex }}</span
      ></mat-panel-title
    >
    <mat-panel-description>
      <div class="show-on-hover-right" *ngIf="hoverButtonTemplate">
        <ng-container
          *ngTemplateOutlet="
            hoverButtonTemplate;
            context: { shapeStore: shapeStore }
          "
        ></ng-container>
      </div>
      <div *ngIf="staticButtonTemplate">
        <ng-container
          *ngTemplateOutlet="
            staticButtonTemplate;
            context: { shapeStore: shapeStore }
          "
        ></ng-container>
      </div>
    </mat-panel-description>
  </mat-expansion-panel-header>
  <div class="shape-list-shape-content">
    <!--add asIsOrder since keyvalue sorts by default https://github.com/angular/angular/issues/42490#issue-912301090-->
    <ng-container *ngFor="let tag of shapeTagsMap | keyvalue: asIsOrder">
      <div [hidden]="(tag.value | async) === ''">
        <div
          class="shape-list-shape-tag"
          [class.within-group-shape]="memberOfGroup"
          [class.selected-shape-item]="isShapeSelected$ | async"
        >
          <span class="tag-label">{{ tag.key }}</span>
          <span class="tag-value subtitle-03">{{ tag.value | async }}</span>
        </div>
      </div>
    </ng-container>
    <h3-focusable-timeline
      *ngIf="maxFrameNumber > 0"
      [shapeStore]="shapeStore"
      [showKeyframeIndicator]="true"
    ></h3-focusable-timeline>
  </div>
</mat-expansion-panel>
